<div>
  <app-header [title]="title"></app-header>
  <div class="container-md p-3 p-sm-5 mt-3 shadow-lg rounded">
    <div class="row" id="Addressat">
      <div class="col">
        <h4>
          {{ addressant }}
        </h4>
      </div>
    </div>
    <div class="row mt-5" id="Offener-Brief">
      <div class="col" [innerHtml]="_returnHtmlFromRichText(text)"></div>
    </div>
    <div class="row mt-3" id="Kontakt">
      <div
        *ngIf="contactNotice"
        class="col"
        [innerHtml]="_returnHtmlFromRichText(contactNotice)"
      ></div>
    </div>
    <div class="row align-items-center mt-3">
      <div class="col-12 align-self-center">
        <h4 style="margin-bottom: 0">
          <span *ngIf="signees?.length && signees.length != 0; else noOrg">
            <span *ngIf="signees?.length > 1; else oneOrg"
              >Folgende {{ signees.length }} Personen haben</span
            >
            <ng-template #oneOrg>Folgende Person hat </ng-template>
            unterzeichnet:</span
          >
          <ng-template #noOrg
            >Sie können Erstunterzeichnende werden!</ng-template
          >
        </h4>
      </div>
    </div>
    <!-- Signees -->
    <div class="row row mt-3 align-items-start" id="Unterzeichner">
      <div class="col text-left">
        <ng-template ngFor let-signee [ngForOf]="signees">
          <p>
            <span *ngIf="signee?.fields?.name">{{ signee?.fields?.name }}</span>
            <span *ngIf="signee?.fields?.title"
              >, {{ signee?.fields?.title }}</span
            >

            <span *ngIf="signee?.fields?.organisation"
              >, {{ signee?.fields?.organisation }}</span
            >
          </p>
        </ng-template>
      </div>
      <!-- <app-signee *ngIf="signee && signee?.fields" [name]="signee.fields.name" [logo]="signee.fields.logo"
          [website]="signee.fields.website" [listOfSigningNames]="signee.fields.listOfSigningNames"
          >
        </app-signee> -->
    </div>
    <!-- Sources -->
    <div
      class="row mt-3"
      id="sources"
      *ngIf="sources?.length && sources.length != 0"
    >
      <div class="col">
        <h4>Quellen:</h4>
        <div *ngFor="let source of sources; let i = index">
          <span [id]="'source-'+(i+1)"
            [innerHTML]="_returnHtmlFromRichText(source.fields.text)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</div>
